import React, { useState } from "react";
import OrderManagement from "./OrderManagement";
import ProductManagement from "./ProductManagement";
import TicketManagement from "./TicketManagement";
import WalletManagement from "./WalletManagement"; // Import the new component
import "./adminpanel.css";

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("orders");

  return (
    <div className="admin-panel">
      <h2 className="admin-title">Admin Panel</h2>

      <div className="admin-cards">
        <div
          className={`admin-card ${activeTab === "orders" ? "active" : ""}`}
          onClick={() => setActiveTab("orders")}
        >
          <h3>Order Management</h3>
        </div>
        <div
          className={`admin-card ${activeTab === "products" ? "active" : ""}`}
          onClick={() => setActiveTab("products")}
        >
          <h3>Product Management</h3>
        </div>
        <div
          className={`admin-card ${activeTab === "tickets" ? "active" : ""}`}
          onClick={() => setActiveTab("tickets")}
        >
          <h3>Ticket Management</h3>
        </div>
        <div
          className={`admin-card ${activeTab === "wallet" ? "active" : ""}`}
          onClick={() => setActiveTab("wallet")}
        >
          <h3>Wallet Management</h3>
        </div>
      </div>

      <div className="admin-content">
        {activeTab === "orders" && <OrderManagement />}
        {activeTab === "products" && <ProductManagement />}
        {activeTab === "tickets" && <TicketManagement />}
        {activeTab === "wallet" && <WalletManagement />}
      </div>
    </div>
  );
};

export default AdminPanel;
